import React from 'react'
import {SortableHandle} from 'react-sortable-hoc'

const DragHandle = SortableHandle(() => <span className='bp3-icon-standard bp3-icon-drag-handle-horizontal pointer' />)

export default DragHandle
